/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".table-cell-margin[_ngcontent-%COMP%]{margin-right:20px}.table-last-cell-margin[_ngcontent-%COMP%]{text-align:center}.tc-last-column-width[_ngcontent-%COMP%]{width:22px}"];
export { styles as styles };
